import { styled } from '@acko-tech/building-blocks.ui.common';

export const InstructionWrapper = styled.div`
    margin: 24px 0 120px 0;
    min-height: 300px;

    @media screen and (min-width: 780px) {
        min-height: 260px;
    }
`;

export const InstructionTitle = styled.div`
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #737f8b;
    margin-bottom: 12px;
`;

export const InstructionRowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
`;

export const Dot = styled.div`
    display: flex;
    margin: 5px 10px 0 0;
`;

export const Instruction = styled.div`
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #434f5a;
`;
